import React from "react";
import PropTypes from "prop-types";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import moment from "moment";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import config from "@/utils/config";
import { newsInfoDisplayAvailabilityFlagEnum, eventEnum } from "@/utils/enum";
import BackButton from "@/react-components/BackButton";
import MainDetail from "@/react-components/MainDetail";
import { modeEnum } from "@/utils/enum";

class InformationDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isExist: false };
    this.exist();
  }

  exist = () => {
    const { mode } = this.props;
    if (mode === modeEnum.pageEditing) {
      this.setState({ isExist: true });
      return;
    }
    const {
      sitecoreContext: { itemId },
    } = this.props;
    api.information
      .exist(itemId)({ newsId: itemId })
      .then((response) => {
        if (
          response.newsInfoDisplayAvailabilityFlag ===
          newsInfoDisplayAvailabilityFlagEnum.yes
        ) {
          this.setState({ isExist: true });
          this.read();
        } else {
          config.eventEmitter.emitEvent(eventEnum.notFound);
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  read = () => {
    const {
      sitecoreContext: { itemId },
    } = this.props;
    api.information
      .read(itemId)(null, { newsId: itemId })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const {
      data,
      props,
      children,
      sitecoreContext: {
        route: { fields },
      },
      mode,
    } = this.props;
    const { isExist } = this.state;
    return (
      <React.Fragment>
        {isExist || mode === modeEnum.pageEditing ? (
          <React.Fragment>
            <BackButton />
            <div className="information-detail-container">
              <div className="information-detail-container-title">
                {fields?.title?.value}
              </div>
              <div className="information-detail-container-date">
                {moment(fields?.publicDate?.value)
                  .utcOffset(9)
                  .format("yyyy.MM.DD")}
              </div>
              <MainDetail
                data={data}
                props={props}
                showRelated={false}
                showEvaluate={false}
              >
                {children}
              </MainDetail>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

InformationDetail.propTypes = {
  data: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    mode: state?.config?.mode,
  };
};

export default connect(mapStateToProps)(
  withSitecoreContext()(InformationDetail)
);
